<template>
  <div>
    <div class="main">
		
      <img :src="pcHomeBannerArr[0].img" @click="swiperClick(pcHomeBannerArr[0])" class="bannerImg" v-if="pcHomeBannerArr.length>0"/>
	  <div class="wrap" v-if="pcHomeSlidArr.length>0">
	    <div class="common-title">{{home_ad_title||""}}</div>
	    
	    <div class="look-more" @click="more">
	      查看更多
	      <!-- <i class="icon iconfont iconmore"></i> -->
	    </div>
	  </div>
	  
     <!-- <TitleSlot title :showMore="false" moreDesc="查看更多"></TitleSlot> -->
      <el-carousel indicator-position="outside" v-if="pcHomeSlidArr.length>0">
        <el-carousel-item class="list" v-for="(item,index) in pcHomeSlidArrList">
          <div v-for="(iitem,index) in item">
            <img :src="iitem.img"  @click="swiperClick(iitem)" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import TitleSlot from "./TitleSlot.vue";
import chunk from "lodash.chunk";
import { isSafeRedirect } from '@/utils/index.js'
export default {
  name: "ActivityImg",
  components: {
    TitleSlot
  },
  props: {
    imgList: {
      type: [Object, Array],
      default: function() {
        return [];
      }
    }
  },
  computed: {
    pcHomeSlidArrList() {
      return chunk(this.pcHomeSlidArr, 5);
    }
  },
  data() {
    return {
		pcHomeSlidArr:[],
		pcHomeBannerArr:[],
		home_ad_url:'',//查看更多url地址
		home_ad_title:''
	};
  },
  methods: {
	gethomeBanner(){
		let data = {
			codes: ["pc_home_slid","pc_home_banner"]
		};
		let _this = this;
		this.$api.getCarouselLists(data).then(res => {
			if (res.status) {
				if(res.data.list.pc_home_banner){
					_this.pcHomeBannerArr = res.data.list.pc_home_banner;
				}
				if(res.data.list.pc_home_slid){
					_this.pcHomeSlidArr = res.data.list.pc_home_slid;
				}
			}
			
			if(_this.$store.state.shopMenu && _this.$store.state.shopMenu.settings){
				_this.$store.state.shopMenu.settings.forEach(function(i,j){
					if(i.k=='home_ad_url'){
						_this.home_ad_url = i.val;
					}
				})
			}
		});
	},
	// /点击
	swiperClick(v) {
		// type 1 url 直接跳转
		// 2 商品
		//  3 文章
		// 4  文章分类
		// 5 智能表单
		this.$api.addRecord({
			'type': '5',
			'api_method': "advert.getcarousellists",
			"platform": "1",
			"code": v.code,
			"rel_id": v.id
		})
		
		if (v.type == 1 && v.val!='#') {
			if (isSafeRedirect(v.val)) {
				window.open(v.val, '_blank')
			}
			return
		}
		if (v.type == 2) {
			this.$router.push({
				path: `detail/${v.val}`,
			})
			return
		}
	},
	more(){
		console.log(this.home_ad_url);
		if(this.home_ad_url){
			if (isSafeRedirect(this.home_ad_url)) {
				window.open(this.home_ad_url, '_blank')
			}
			return
		}
	
	}
  },
  mounted() {
	  
	  this.gethomeBanner();  
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.main {
  /* margin-bottom: 50px; */
  .bannerImg {
    width: 100%;
    margin-top: 10px;
  }
  .list {
    display: flex;
    align-items: center;
    height: 300px;
    overflow: hidden;
    > div {
      margin: 0 8px;
      cursor: pointer;
      > img {
        width: 230px;
        height: 300px;
      }
    }
    > div:nth-last-child(1) {
      margin: 0;
    }
  }
}
</style>


<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding-top: 20px;
  .common-title {
    width: 234px;
    height: 24px;
    line-height: 24px;
    font-size: 22px;
    font-weight: 200;
    color: #333;
  }
  .look-more {
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: $theme-color;
      .icon {
        color: $theme-color;
      }
    }
    .icon {
      color: #b0b0b0;
      margin-left: 4px;
    }
  }
}
</style>
